import { IMultiSelectProps, useMultiSelect } from '../multi-select';
import BaseMultiSelect from '../multi-select/base-multi-select';
import { treeSelectOnChangeEventWrapper } from '../../../events/tree-select-onchange';

const TreeSelect = ({ id }: IMultiSelectProps) => {
  const {
    props: { required, error, options, label, show, value, maxReached, warn },
    setValue,
    validate,
  } = useMultiSelect(id);

  if (!show || !options) return null;

  return (
    <BaseMultiSelect
      id={id}
      label={label}
      options={options}
      value={value}
      required={required}
      error={error}
      warn={warn}
      maxReached={maxReached}
      groupBy
      onSelect={treeSelectOnChangeEventWrapper(id, value, setValue, validate)}
    />
  );
};

export default TreeSelect;
